import createActionCable from '../utils/actioncable';
import createToast from '../utils/toast';

const listener = {
  received: data => {
    if (!data.title) return;

    createToast({
      message: data.message,
      title: data.title,
      icon: data.icon,
      url: data.url,
      type: data.type
    });
  }
};

const channelData = { channel: 'WebNotificationsChannel' };
// Only create the subscription if web notifications are enabled, otherwise we
// can avoid unnecessary ActionCable traffic. Currently turned off for everyone
if (globalThis.web_notifications_enabled) {
  createActionCable().subscriptions.create(channelData, listener);
}
